// @flow
export const filterId: 'details' = 'details';
